export default __webpack_public_path__ + "static/blob-497f4b79f9638cd6fe03961ab72f7b89.png";